import {Component} from "@angular/core";
import {ModalPaymentService} from "../../services/ux/modal-payment.service";
import {UserHttpClientService} from "../../data/user-http-client.service";
import {SessionService} from "../../services/session.service";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { SetTitleService } from "src/app/services/set-title.service";


@Component({
    templateUrl: "home.component.html",
    styles: [
        `
            .service-wrapper-other {
                height: 350px;
            }
        `
    ]
})
export class HomeComponent {
    environment: any;

    constructor(
      private modalService: ModalPaymentService,
      private userHttpClient: UserHttpClientService,
      public auth: SessionService,
      private translateService: TranslateService,
      private settitleservice : SetTitleService
    ) {
      this.environment = environment
    }

    ngOnInit() {
      this.settitleservice.sendTitle("Home");
    }

    onQrCodeShow() {
        this.modalService.open();
    }

    getBackgroundImg() {
      return  `url('${environment.homeImage}')`
    }

    getTitle() {
      return this.translateService.instant(`RootCommon.${environment.homeTitle}`)
    }
    
    getSubTitles() {
      if (!environment.homeSubTitle) return []
      const subTitleKeys = environment.homeSubTitle.split(" || ")
      return subTitleKeys.map(key => this.translateService.instant(`RootCommon.${key}`))
    }
}
